import { ICardFootballCalendar, IMatchRow } from '@sky-it-livedata/livedata-sports-design-system';
import { slugify } from '@sky-it-livedata-libraries/livedata-commons';
import { DataCardCalendarQuery } from '../types';
import { isValidDataCardCalendar } from './typeguards';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { CreateCardCompetitionCalendarInputSchema } from 'appsync';
import { intcmpMap } from '../../../utils/intcmp';

export default (obj: DataCardCalendarQuery): ICardFootballCalendar => {
  if (isValidDataCardCalendar(obj)) {
    CreateCardCompetitionCalendarInputSchema().parse(obj.data.getCardCompetitionCalendar, {reportInput: true});

    const { competitionId, customCompetitionName, calendarAndResultsLink, matchRoundList } =
      obj?.data?.getCardCompetitionCalendar;

    const days: ICardFootballCalendar['days'] = [];

    // eslint-disable-next-line functional/no-let
    let availableGameSpace = 5;

    const competitionSlug = slugify(customCompetitionName!);

    for (const round of matchRoundList!) {
      for (const day of round!.matchDayList!) {
        const matches = day!.matchList!.slice(0, availableGameSpace) as IMatchRow[];

        days.push({
          title: round!.competitionPhase ?? `G${round!.round}`,
          date: day!.date!,
          round: round!.round!,
          matches: matches.map((match) => {
            const date = new Date((match.date as string) || 'now');
            const dateString = date.toLocaleTimeString('it-IT', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              timeZone: 'Europe/Rome',
            });

            return {
              ...match,
              away: {
                ...match.away,
                logoUrl: match.away.negativeLogoUrl ?? match.away.logoUrl,
              },
              home: {
                ...match.home,
                logoUrl: match.home.negativeLogoUrl || match.home.logoUrl,
              },
              targetUrl: match.link || undefined,
              title: `${dateString}. ${match.home.seoName} contro ${match.away.seoName}`,
              trackingData: { intcmp: `skysport_homepage_card-calendar-football-${competitionSlug}_detail-link` },
            };
          }),
        });

        availableGameSpace -= matches.length + 1;
        if (availableGameSpace <= 0) {
          break;
        }
      }
      if (availableGameSpace <= 0) {
        break;
      }
    }

    days.sort((a, b) => {
      const dateResult = new Date(a.date).getTime() - new Date(b.date).getTime();
      if (dateResult !== 0) {
        return dateResult;
      }

      return b.round - a.round;
    });

    return {
      ctaLink: calendarAndResultsLink!,
      competitionId: parseInt(competitionId, 10),
      customCompetitionName: customCompetitionName!,
      days,
      trackingData: { 'analytics-element': `card-calendar-football-${competitionSlug}` },
      cardCtaTrackingData: {
        intcmp: intcmpMap.dataCardCalendar.getIntcmp(competitionSlug),
      },
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in DataCardCalendarQuery object',
      data: obj
    });
  }
};
